export enum RegistrationEvent {
  REG_INIT = 'RegistrationInitatedEvent',
  REG_PAGE_LOADED = 'RegistrationPageLoadEvent',
  REG_TOGGLE_REFERRAL_INPUT = 'RegistrationToggleReferralInputEvent',
  PERSONAL_DETAILS_COMPLETED = 'PersonalDetailsCompletedEvent',
  REG_COMPLETED = 'RegistrationCompletedEvent',
  REG_FAILURE = 'RegistrationFailureEvent',
  REG_ABANDONED = 'RegistrationAbandondedEvent',
}
